export class Charts {
  static SalesOrders = 'SalesOrders';
  static SalesContracts = 'SalesContracts';
  static SalesInvoices = 'SalesInvoices';
  static PurchaseOrders = 'PurchaseOrders';
  static PurchaseInvoices = 'PurchaseInvoices';
}
